import { Component, Input, OnInit } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';

@Component({
  selector: 'app-table-connection-status',
  template: `<div class="status-title">
  				<span class="status-circle" ngClass="{{statusClass}}"></span>
  				{{statusText}}
			</div>`,
  styleUrls: ['./table-connection-status.component.scss']
})
export class TableConnectionStatusComponent implements ViewCell, OnInit {

  @Input() value: string | number;
  @Input() rowData: any;  
  
  statusClass : string;
  statusText : string;

  ngOnInit() {
  	if (+this.rowData.verify === 0) {
      this.statusText = 'Unverified';
      this.statusClass = 'not-verified';
    } else if (+this.rowData.verify === 1) {
      this.statusText = 'Verified';
      this.statusClass = 'active';
    }
    else if (+this.rowData.verified === 0) {
      this.statusText = 'Unverified';
      this.statusClass = 'not-verified';
    }
    else if (+this.rowData.verified === 1) {
      this.statusText = 'Verified';
      this.statusClass = 'active';
    }

    if (+this.rowData.status === 0) {
      this.statusText = 'Unverified';
      this.statusClass = 'not-verified';
    } else if (+this.rowData.status === 1) {
      this.statusText = 'Verified';
      this.statusClass = 'active';
    }
  }
}
